import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import { emailValidator } from '../../../../../models/customValidators'
import { BehaviorSubject, Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'

@Component({
    selector: 'app-modal-seting-common-save',
    templateUrl: './modal-common-save.component.html',
    styleUrls: ['./modal-common-save.component.css',
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/main-view.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class ModalCommonSaveComponent implements OnInit, OnDestroy {
    // ****************************TASK COMMON
    contactComonForm: FormGroup
    styleVisibility: any
    modalTimeZoneCommon = 'hidden'
    offsetTmz = []
    filterTimezone
    showOptionTimezone: any
    offsetTmzCopy // copy of optionArr
    defaultTimeZone
    // country
    modalCountryCommon = 'hidden'
    offsetCountry = []
    filterCountry
    showOptionCountry: any
    offsetCountryCopy // copy of optionArr Country
    defaultCountry
    typePlan
    // send mail
    hiddenContactOTC = 'hidden'
    planClass
    changePlan = undefined
    namePlan
    statusEmail
    checkFomatEmail: any
    alerttCommon = true
    arrOrThoComm = [{ id: 0, name: 'Free', nameSave: 'free' }, {
        id: 1,
        name: 'Light ($150 / month)',
        nameSave: 'light',
    }, { id: 2, name: 'Basic (300 / month)', nameSave: 'basic' }, {
        id: 3,
        name: 'Standard ($500 / month)',
        nameSave: 'standard',
    }, { id: 4, name: 'Professional ($800 / month)', nameSave: 'professional' }]
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    offsetTimezoneCopy
    //show terms
    hiddenTerms = 'hidden'
    hiddenPolicy = 'hidden'
    requireEmail = false
    requireMessage = false
    emailCheckSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null)
    modalChangeObserver$ = new Subject<boolean>()

    constructor(private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private modalService: ModalService) {
        modalService.changeEmitted$.takeUntil(this.modalChangeObserver$).subscribe(success => {
            // task common
            if (success[0] === 'activeTimeZoneCommon') {
                this.modalTimeZoneCommon = 'active'
                this.getTimeZone(success[1])
            }
            if (success[0] === 'activeCountryCommon') {
                this.modalCountryCommon = 'active'
                this.getCountry(success[1])
            }
            if (success === 'activeContacOrTho') {
                this.hiddenContactOTC = 'active'
                this.alertLanguage()
            }
            if (success === 'activeShowTerms') {
                this.hiddenTerms = 'active'
                // this.alertLanguage();
            }
            if (success === 'activeShowPolicy') {
                this.hiddenPolicy = 'active'
                // this.alertLanguage();
            }
            if (success === 'alertSaveMail') {
                this.alerttCommon = false
                this.alertLanguage()
            }
            if (success === 'closealertSaveMail') {
                this.alerttCommon = true
            }
        })
        this.validatorFormSendContact()
    }

    ngOnInit() {
        this.emailCheckSubject.pipe(debounceTime(400), distinctUntilChanged()).subscribe(email => {
            if (email) {
                const format = email.slice(email.search('@') + 1)

                this.restApi.http_post('form/checkMx', { host: format }).subscribe(response => {
                    this.checkFomatEmail = response['status']
                    this.requireEmail = false
                })
            }
        })
    }

    ngOnDestroy(): void {
        if(this.modalChangeObserver$){
            this.modalChangeObserver$.next(true)
            this.modalChangeObserver$.unsubscribe()
        }
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            this.hidenModalContact()
            this.hidenModalCountry()
            this.hidenModalTimeZone()
        }
    }

    // ***************************************************** COMMON SETTING ***************************************************************//
    // hiden modal
    hidenModal() {
        // hidden modal contact
        this.hiddenContactOTC = 'hidden'
        this.contactComonForm.reset()
        this.checkFomatEmail = ''
        this.typePlan = ''
    }

    // hidden modal time zone
    hidenModalTimeZone() {
        this.modalTimeZoneCommon = 'hidden'
    }

    hidenModalCountry() {
        this.modalCountryCommon = 'hidden'
    }

    hidenModalContact() {
        this.hiddenContactOTC = 'hidden'
        this.contactComonForm.reset()
    }

    hidenModalTerms(approve = false) {
        this.hiddenTerms = 'hidden'
        if (approve) {
            this._sharedService.emitChangeParent('aproveTerms')
        }
    }

    hidenModalPolicy(approve = false) {
        this.hiddenPolicy = 'hidden'
        if (approve) {
            this._sharedService.emitChangeParent('aproveTPolicy')
        }
    }

    // get list time zone
    getTimeZone(nameTimeZone) {
        const moment = require('moment-timezone')
        const timeZones = moment.tz.names()
        this.offsetTmz = timeZones
        this.offsetTmzCopy = this.offsetTmz.slice()
        if (nameTimeZone) {
            this.showOptionTimezone = 'showOption_' + nameTimeZone
            this.styleVisibility = { visibility: 'visible' }
        }
        // const addTimeZone = [];
        // timeZones.forEach(function (value) {
        //     const tz = moment.tz.zone(value);
        //     const list = tz.abbrs;
        //     const uniqueArray = list.filter(function (item, pos) {
        //         return list.indexOf(item) === pos;
        //     });
        //     addTimeZone.push(value + ' (' + uniqueArray.join(', ') + ')');
        // });
        // this.offsetTmzCopy = addTimeZone.slice();
    }

    getUniqueTimezone(value) {
        const moment = require('moment-timezone')
        const tz = moment.tz.zone(value)
        const list = tz.abbrs
        const uniqueArray = list.filter(function(item, pos) {
            return list.indexOf(item) === pos
        })
        const addTimeZone = uniqueArray ? '(' + uniqueArray.join(', ') + ')' : ''
        return addTimeZone
    }

    getCountry(nameCountry) {
        const countries = require('country-list')()
        this.offsetCountry = countries.getData()
        this.offsetCountryCopy = this.offsetCountry.slice()
        if (nameCountry) {
            this.showOptionCountry = 'showOption_' + nameCountry
            this.styleVisibility = { visibility: 'visible' }
        }
    }

    toggleItem(id, event) {
        this.planClass = id
        this.namePlan = event.target.innerText
        //
        //
    }

    toggleItemType(event) {
        this.typePlan = event.target.innerText
    }

    // search time zone
    searchTimeZone(): void {
        const term = this.filterTimezone
        this.offsetTmz = this.offsetTmzCopy.filter(function(tag) {
            return tag.indexOf(term) >= 0
        })
    }

    selectOptionTimeZone(id) {
        this.showOptionTimezone = 'showOption_' + id
        this.defaultTimeZone = id
        if (this.showOptionTimezone) {
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModalTimeZone()
            const arrTimeZone = [id, 'activeTimeZone']
            this._sharedService.emitChangeParent(arrTimeZone)
            this.filterTimezone = null
        }
    }

    // search country
    searchCountry(): void {
        const term = this.filterCountry
        this.offsetCountry = this.offsetCountryCopy.filter(function(tag) {
            return tag.name.indexOf(term) >= 0
        })
    }

    selectOptionCountry(id, value) {
        this.showOptionCountry = 'showOption_' + id
        this.defaultCountry = id
        if (this.showOptionCountry) {
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModalCountry()
            const arrCountry = [value, 'activeCountry', id]
            this._sharedService.emitChangeParent(arrCountry)
            this.filterCountry = null
        }
    }

    validatorFormSendContact() {
        this.contactComonForm = this.formBuider.group({
            email: ['', [Validators.required, emailValidator()]], message: ['', Validators.required],
        })
    }

    // check format email server
    checkFormatEmail() {
        const email = this.contactComonForm.controls.email.value
        this.emailCheckSubject.next(email)
    }

    isFieldValid(field: string) {
        return !this.contactComonForm.get(field).valid && this.contactComonForm.get(field).touched || this.contactComonForm.get(field).dirty && (this.contactComonForm.get(field).status === 'INVALID') // remove (|| this.campFormGroup.get(field).dirty && (this.campFormGroup.get(field).status === 'INVALID'))
    }

    displayFieldCss(field: string) {

        return {
            'has-error': this.isFieldValid(field),
        }
    }

    // send mail contact
    sendContact(event) {
        const email = this.contactComonForm.controls.email.value
        const message = this.contactComonForm.controls.message.value
        if (!email || message.trim() == '') {
            this.requireEmail = !email
            this.requireMessage = message.trim() == ''
            return
        }
        this.requireEmail = false
        this.requireMessage = false
        const user = JSON.parse(this.authData.getItem('user'))
        const bodyContact: any = {
            data: {
                email: email,
                comment: message,
                contactType: '',
            }, type: 'contact',
        }
        switch (this.typePlan) {
            case 'Change Plan':
                bodyContact.data.contactType = 'plan'
                bodyContact.data.contractType = this.namePlan
                break
            case  'Other':
                bodyContact.data.contactType = 'other'
                break
            default:
                break
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('form', bodyContact, tokenReNew).subscribe(success => {
                this.statusEmail = success['status']
                this.hiddenContactOTC = 'hidden'
                event.show()
            })
        })
        this.hiddenContactOTC = 'hidden'
        this.alertLanguage()
        this.hidenModal()
    }

    alertLanguage() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }

    cancelAlert() {
        this.alerttCommon = true
    }

    saveComon() {
        this._sharedService.emitChangeParent('saveComon')
    }

    alertDiscard() {
        this._sharedService.emitChangeParent('alertDiscard')
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/common/modal-common-save.component.ts